import { Injectable } from '@angular/core';

import * as $ from 'jquery';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  constructor() {}

  showLoader() {
    $('#progress').show();
  }

  hideLoader() {
    $('#progress').hide();
  }
}
